// extracted by mini-css-extract-plugin
export default {"root":"PlasmicInputFiled_root__Dd81G","freeBox":"PlasmicInputFiled_freeBox__aDUXc","input":"PlasmicInputFiled_input__WI02T"};